<template>
  <Checkbox
    class="formily-checkbox"
    :option="option"
    :position="position"
    :horizontal="horizontal"
    :hollowStyle="hollowStyle"
    :indeterminate="indeterminate"
    v-model="model"
  >
  </Checkbox>
</template>

<script>
import { Checkbox } from '@didi/rich-ui'
export default {
  components: { Checkbox },
  data() {
    return {
      itemValue: false
    }
  },
  props: {
    option: {},
    position: {
      default: 'right'
    },
    horizontal: {},
    hollowStyle: {},
    value: {},
    indeterminate: {}
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.itemValue = newVal
      }
    }
  },
  computed: {
    model: {
      get() {
        return this.value || this.itemValue
      },
      set(newVal) {
        this.itemValue = newVal
        this.$emit('input', newVal)
        this.$emit('change', newVal)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
